import React from "react";

const LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_xab-uk-accounts/artifacts/8bylwrpf_New%20Logo.jpg";

export const Logo = ({ variant = "light", size = 36 }) => {
  // variant: "light" (white text on dark bg) or "dark" (dark text on light bg)
  const textColor = variant === "light" ? "text-white" : "text-[#2A3430]";
  const accent = "text-[#C57A5A]";
  return (
    <a
      href="#top"
      data-testid="brand-logo"
      className="flex items-center gap-3 group"
    >
      <span
        className="inline-flex items-center justify-center rounded-xl bg-white/95 ring-1 ring-black/5 p-1.5 shadow-sm transition-transform duration-300 group-hover:scale-[1.02]"
        style={{ width: size, height: size }}
      >
        <img
          src={LOGO}
          alt="Xab Accountants logo"
          className="h-full w-full object-contain"
          loading="eager"
        />
      </span>
      <span className="leading-none">
        <span className={`block font-serif-display text-[1.35rem] tracking-tight ${textColor}`}>
          Xab<span className={accent}>.</span>
        </span>
        <span className={`block text-[10px] uppercase tracking-[0.18em] ${variant === "light" ? "text-white/60" : "text-[#2A3430]/70"}`}>
          Accountants
        </span>
      </span>
    </a>
  );
};

export default Logo;
